/** 수량(Decimal 문자열 포함)을 화면 표기용으로 변환 */
export const formatOrderQuantity = (value: string | number | null | undefined) =>
  Number(value ?? 0).toLocaleString("ko-KR", { maximumFractionDigits: 3 });

export const formatDate = (iso: string | null | undefined) =>
  iso ? new Date(iso).toLocaleDateString("ko-KR") : "-";
